import { create } from 'zustand';

interface AwardPrize {
  receivedPrizeList: number[],
  changePrizeStatus: (number) => void
}

export const useAwardPrizeStore = create<AwardPrize>((set, get) => ({
  receivedPrizeList: [],
  changePrizeStatus: (actIds: number[]) => {
    set(state => ({
      receivedPrizeList: [...state.receivedPrizeList, ...actIds],
    }));

    return get().receivedPrizeList;
  },

  getPrizeIsReceived(actId) {
    const receivedList = get().receivedPrizeList;
    return receivedList.indexOf(actId) !== -1;
  },
}));
